import './GoogleRatingPopup.css';


const GoogleRatingPopup = ({setShowGooglePopup}) => {
 
  return (
      <div className="modal-overlay">
    <div className="modal-content">
      <h2 style={{ color: '#333', marginBottom: '10px' }}>Thank you for the 10! 🎉</h2>
      <p style={{ color: '#555', marginBottom: '25px', fontSize: '16px' }}>
        Loved your experience? Please rate us on Google!
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
        <button 
          onClick={() => setShowGooglePopup(false)} 
          className="cancel-btn"
        >
          Maybe Later
        </button>
        <a 
          href="https://g.page/r/CTyOvwBvDmoVEBM/review" 
          target="_blank" 
          rel="noopener noreferrer"
          onClick={() => setShowGooglePopup(false)} 
        >
          <button className="google-btn">
            Rate us on Google
          </button>
        </a>
      </div>
    </div>
  </div>
  )
}

export default GoogleRatingPopup